import { Component } from "@angular/core";
import { MdDialog, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AssignSmartCal360NCustomerComponent } from "./assign-smartcal360n-customer/assign-smartcal360n-customer.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import Swal from "sweetalert2";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { SmartCal360FilterPipe } from "./pipes/smartcal360FilterPipe";

@Component({
    selector:'license-smartcal360',
    template:require('./smartcal360.component.html'),
    styles:[require('./smartcal360.component.css')],
})
export class LicenseModuleSmartcal360Component{
    originalSmartCal360NLicenseList=[];
    smartCal360NLicenseList=[];
    filteredSmartCal360NLicenseList=[];
    smartCal360NLicenseForm:FormGroup
    errorMessage='';
    selectedRow;
    submitted=false;
    error='';
    selectedLicenseKeyIdList=[];
    pager:any={};
    pagedItems=[];
    IsAddEdit;
    IsDelete;
    ProductId;
    currentSortColumn='';
    currentSortOrder='';
    filterSerialNumber=null;
    serialNoValidationMessage="Serial number should be greater than zero."
    constructor(
        private dialog:MdDialog,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private formBuilder:FormBuilder,
        private adalService:AdalService,
        private router:Router,
        private exportService:ExportToCSVService,
        private pagerService:PagerService,
        private route:ActivatedRoute,
        private userService:UserService,
        private filterPipe:SmartCal360FilterPipe
    ){
        if (!this.adalService.getCachedToken()) {
            setTimeout(() => {
                this.router.navigate(["login"]);
            }, 100);
        }
        
            appLoader.close();
            route.params.subscribe((params)=>{
                this.ProductId=params['productId']
            })
            this.getUserRights();
            this.getSmartCal360NLicenseDisplayDetail();
            this.buildForm();
        
        
    }
    getUserRights(){
        let UserId=Number(localStorage.getItem('userid'))
        this.userService.getUserLicenseRightById(UserId,this.ProductId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.IsAddEdit=data.DataObject.IsAddEdit;
                this.IsDelete=data.DataObject.IsDelete;
            }
        })
    }
    selectRow(index,selectedRowDetail){
        this.selectedRow[index]=this.selectedRow[index]==index?null:index;
    }
    buildForm(){
        this.smartCal360NLicenseForm=this.formBuilder.group({
            SerialNoFrom:[null,[Validators.required]],
            SerialNoTo:[null,[Validators.required]],
            SearchSerialNumber:[null,[Validators.min(1)]]
        })
    }
    setPage(page: number) {
        this.smartCal360NLicenseList=[...this.originalSmartCal360NLicenseList];
        this.applySort();
        this.filteredSmartCal360NLicenseList=this.filterPipe.transform(this.smartCal360NLicenseList,this.filterSerialNumber)
        this.pager = this.pagerService.getPager(this.filteredSmartCal360NLicenseList.length, page);
        this.pagedItems = this.filteredSmartCal360NLicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.selectedRow=new Array(this.pagedItems.length).fill(null)
        this.errorMessage=(this.pagedItems.length==0)?"No records found.":"";
    }
    exportToCSV(){
            let jsonData:Array<any>=[];
            if(this.smartCal360NLicenseList){
                this.smartCal360NLicenseList.forEach(element => {
                    jsonData.push({
                        ProductSerialNo:element.ProductSerialNo,
                        ProductActivationKey:element.ProductActivationKey,
                        CustomerName:element.CustomerName,
                        CreationDate:element.CreatedDate
                    })
                });
                this.exportService.exportToCsv(jsonData,'SmartCal360N')
            }
            else{
                Swal.fire({
                    title:'No data',
                    text:'There is no data available to export to CSV file.',
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
            }
    }
    generateSmartCal360NLicenseKey(){
        this.errorMessage='';
        this.submitted=true;
        if(this.smartCal360NLicenseForm.controls.SerialNoFrom.errors || this.smartCal360NLicenseForm.controls.SerialNoTo.errors ){
            return;
        }
        if(this.smartCal360NLicenseForm.value.SerialNoFrom<0 || this.smartCal360NLicenseForm.value.SerialNoTo<0){
            this.errorMessage='Serial Number cannot be negative';
            return;
        }
        else if(this.smartCal360NLicenseForm.value.SerialNoFrom>this.smartCal360NLicenseForm.value.SerialNoTo){
            this.errorMessage='Serial Number From value cannot be greater than Serial Number To Value';
            return;
        }
        this.appLoader.open();
        let model={
            ProductSerialNoFrom:this.smartCal360NLicenseForm.value.SerialNoFrom,
            ProductSerialNoTo:this.smartCal360NLicenseForm.value.SerialNoTo,
            CreatedBy:Number(localStorage.getItem('userid'))
        }
        this.licenseService.generatesmartcal360NLicenseKey(model).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalSmartCal360NLicenseList=data.DataObject;
                this.smartCal360NLicenseList=[...this.originalSmartCal360NLicenseList];
                this.setPage(1);
                this.clear();
            }
            else{
                this.errorMessage=data.Error;
            }
            this.appLoader.close()
            
        })
    }
    openAssignCustomerDialog(){
        for(let i=0;i<this.selectedRow.length;i++){
            if(this.selectedRow[i]!=null){
                this.selectedLicenseKeyIdList.push(this.pagedItems[i].SmartCAL360NLicenceKeyId)
            }
        }
        if(this.selectedLicenseKeyIdList.length>0){
            let assignSmartCal360NCustomerDialogRef:MdDialogRef<AssignSmartCal360NCustomerComponent>=this.dialog.open(AssignSmartCal360NCustomerComponent,{
                width:'80%',
                height:'81%',
                data:{
                    SmartCal360NLicenseData: this.originalSmartCal360NLicenseList,
                    SelectedLicensesId:this.selectedLicenseKeyIdList
                },
                disableClose:true
            })
            assignSmartCal360NCustomerDialogRef.afterClosed().subscribe((result)=>{
                this.originalSmartCal360NLicenseList=result;
                this.smartCal360NLicenseList=[...this.originalSmartCal360NLicenseList];
                this.setPage(this.pager.currentPage);
                this.selectedRow.fill(null);
                this.selectedLicenseKeyIdList=[]
            })
        }
        else{
            Swal.fire({
                title:'No Serial Number Selected',
                text:'Please select at least one Serial Number',
                showConfirmButton:true,
                confirmButtonColor:'#FFCA28'
            })
        }
    }
    getSmartCal360NLicenseDisplayDetail(){
        this.appLoader.open();
        this.licenseService.getSmartCal360NLicenseDetails().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalSmartCal360NLicenseList=data.DataObject;
                this.smartCal360NLicenseList=[...this.originalSmartCal360NLicenseList];
                this.setPage(this.pager.currentPage);
            }
            else{
                
            }
            this.appLoader.close();
        });
    }
    clear(){
        this.smartCal360NLicenseForm.patchValue({
            SerialNoFrom:null,
            SerialNoTo:null
        })
        this.error='';
        this.errorMessage='';
        this.submitted=false;
    }
    onSortChange(event){
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    }
    search(){
        this.filterSerialNumber=this.smartCal360NLicenseForm.value.SearchSerialNumber;
        this.setPage(1)
    }
    clearSearch(){
        this.smartCal360NLicenseForm.get('SearchSerialNumber').setValue(null);
        this.filterSerialNumber=null;
        this.setPage(1);
    }
    applySort(){
        if(!this.currentSortColumn || !this.currentSortOrder) return;
        this.smartCal360NLicenseList=this.smartCal360NLicenseList.sort((a,b)=>
            {
                if(this.currentSortOrder==='asc'){
                    if(typeof a[this.currentSortColumn] === 'number'){
                        return a[this.currentSortColumn]-b[this.currentSortColumn]
                    }
                    else{
                        a[this.currentSortColumn]=a[this.currentSortColumn] || '';
                        return a[this.currentSortColumn].localeCompare(b[this.currentSortColumn])
                    }
                }
                else if (this.currentSortOrder==='desc'){
                    if(typeof a[this.currentSortColumn] === 'number'){
                        return b[this.currentSortColumn]-a[this.currentSortColumn]
                    }
                    else{
                        b[this.currentSortColumn]=b[this.currentSortColumn] || '';
                        return b[this.currentSortColumn].localeCompare(a[this.currentSortColumn])
                    }
                }
                else {
                    return 0;
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartcal360/smartcal360.component.ts